<template>
  <el-card
    class="h-full absolute inset-0 z-10"
    v-loading="uploadLoading"
    :element-loading-text="uploadProgressText"
  >
    <div class="h-full flex flex-col">
      <div class="mb-10px">
        <span
          v-if="this.operateType !== 'read'"
          class="border-l-3 border-color-primary pl-10px text-18px"
          >{{ pageTitle }}</span
        >
        <el-page-header v-else @back="dialogVisible = false" :content="pageTitle"></el-page-header>
      </div>
      <div class="flex-1 overflow-y-auto pr-100px">
        <el-form
          :model="formData"
          ref="formRef"
          label-width="150px"
          :rules="formRules"
          :disabled="operateType === 'read'"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('课件名称')}`" prop="name">
                <el-input
                  v-model="formData.name"
                  :placeholder="`${$t('请输入')}`"
                  :maxlength="20"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('主讲人')}`" prop="speaker">
                <el-input
                  v-model="formData.speaker"
                  :placeholder="`${$t('请输入')}`"
                  :maxlength="20"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('制作人')}`" prop="producer">
                <el-input
                  v-model="formData.producer"
                  :placeholder="`${$t('请输入')}`"
                  :maxlength="20"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('课件简介')}`" prop="introduction">
                <el-input
                  type="textarea"
                  clearable
                  show-word-limit
                  :maxlength="500"
                  :autosize="{ minRows: 2 }"
                  v-model="formData.introduction"
                  :placeholder="`${$t('请输入')}`"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="`${$t('培训素材')}`" prop="isHasFile" ref="vioFormItem">
                <!-- <uploadCom
                  ref="uploadComVio"
                  :fileTypeList="['ogg', 'webm', 'mp4', 'mov', 'm3u8']"
                  @update:file="updateFile($event, 'file', 'vioFormItem')"
                  :fileNum="9"
                  @delete="deleteFile"
                  delText="是否删除该视频素材，如果删除，则相关培训视频和节点也同时删除！"
                  :disabled="operateType === 'read'"
                /> -->
                <template v-if="operateType !== 'read'">
                  <UploadChunkFile
                    :maxFileCount="9"
                    fileAccept="ogg,webm,mp4,mov,m3u8"
                    :singleFile="false"
                    @on-progress="onUploadProgress"
                    @on-error="uploadLoading = false"
                    @filesUploadComplete="onUploadSuccess"
                    :fileList="fileList"
                    ref="uploadChunk"
                  ></UploadChunkFile>
                  <div class="mt-15px">支持ogg,webm,mp4,mov,m3u8格式附件</div>
                </template>
                <div v-show="fileList.length" class="inline-block">
                  <div
                    :key="index"
                    v-for="(item, index) in fileList"
                    class="p-0px hover:bg-slate-100 flex items-center"
                  >
                    <span class="cursor-pointer" @click="onPreview(item)">{{ item.fileName }}</span>
                    <span
                      class="ml-5px cursor-pointer"
                      v-if="operateType !== 'read'"
                      @click="removeVideoFile(item, index)"
                    >
                      <i
                        class="icon-bg-delete iconfont hover:text-hex-$buttonPrimaryBg hover:shadow"
                      ></i>
                    </span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="`${$t('上传课件封面')}`" prop="cover" ref="picFormItem">
                <uploadCom
                  ref="uploadComPic"
                  :fileTypeList="['jpg', 'png', 'gif']"
                  @update:file="updateFile($event, 'picture', 'picFormItem')"
                  :fileNum="1"
                  :disabled="operateType === 'read'"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="fileList.length">
            <h3 class="mb-20px">设置试题及弹出节点</h3>
            <div v-for="item in fileList" :key="item.id" class="ml-20px">
              <div class="flex mb-50px">
                <div>
                  <VideoCom :fileId="[item.id]" @sentTime="sentTime($event, item.id)">
                    <template v-slot:setNode="{ slotProp }">
                      <el-button
                        type="primary"
                        @click="onClick(slotProp, item.id)"
                        :disabled="operateType === 'read'"
                        >设置节点</el-button
                      >
                    </template>
                  </VideoCom>
                </div>
                <div class="ml-30px flex-1">
                  <TableCom
                    :disabled="operateType === 'read'"
                    :tableData="tableData[item.id]"
                    @linkTopic="linkTopic($event, item.id)"
                    @clearNode="clearNode($event, item.id)"
                    @removeTopic="removeTopic($event, item.id)"
                  />
                </div>
              </div>
            </div>
          </el-row>
        </el-form>
      </div>
      <div class="flex justify-center mt-20px" v-if="this.operateType !== 'read'">
        <el-button type="primary" size="small" @click="submitForm(false)" :loading="loading"
          >保存</el-button
        >
        <el-button size="small" @click="dialogVisible = false" :loading="loading">取消</el-button>
      </div>
    </div>
    <!-- 选择试题 -->
    <ChooseTopic
      v-if="pointDialog"
      :pointProps="pointProps"
      @add-risk-point="addRiskPoint"
      @cancel="pointDialog = false"
    />
  </el-card>
</template>

<script>
import { CoursewareApi } from '@wiz-api/training-management'
import { FileApi } from '@wiz-api/file-management'
import uploadCom from '@/modules/safety-factor-sm/components/uploadCom'
import UploadChunkFile from '@/components/safety/UploadFile/UploadChunkFile'
import VideoCom from '../VideoPlay'
import ChooseTopic from '../ChooseTopicOriginForm'
import TableCom from './TableCom'

const coursewareApi = new CoursewareApi()
const fileApi = new FileApi()
export default {
  name: 'add-course-ware',
  components: { uploadCom, VideoCom, ChooseTopic, TableCom, UploadChunkFile },
  props: {
    operateType: {
      default: '',
      type: String,
    },
    operateData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      formRules: {
        name: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
        speaker: [{ required: true, message: this.$t('请输入'), trigger: ['blur', 'change'] }],
        cover: [{ required: true, message: this.$t('请上传'), trigger: ['blur', 'change'] }],
        isHasFile: [{ required: true, message: this.$t('请上传'), trigger: ['blur', 'change'] }],
      },
      formData: {
        name: '',
        speaker: '',
        producer: '',
        introduction: '',
        cover: '',
        isHasFile: '',
      },
      tableData: {},
      videoTimeLen: {},
      fileList: [],
      pointDialog: false,
      pointProps: {
        visible: false,
      },
      currentId: '',
      currentTime: '',
      pageTitle: '',
      loading: false,
      uploadLoading: false,
      uploadProgressText: '',
    }
  },
  mounted() {},
  created() {
    const title = {
      create: '新增',
      update: '编辑',
      read: '详情',
    }
    this.pageTitle = this.$t(title[this.operateType])
    if (this.operateType === 'update' || this.operateType === 'read') {
      this.initInfoData()
    }
  },
  methods: {
    async onPreview(file) {
      const [err, res] = await fileApi.download(file.id, { returnType: 'Blob' })
      if (!err) {
        const blob = new Blob([res], {
          type: 'application/pdf',
        })
        const blobUrl = window.URL.createObjectURL(blob)
        const templink = document.createElement('a')
        templink.style.display = 'none'
        templink.href = blobUrl
        templink.setAttribute('download', `${file.fileName}`)
        document.body.appendChild(templink)
        templink.click()
        document.body.removeChild(templink)
        window.URL.revokeObjectURL(blobUrl)
        this.$message({
          type: 'success',
          message: '下载成功!',
        })
      }
    },
    removeVideoFile(file, index) {
      this.fileList.splice(index, 1)
      delete this.tableData[file.id]
      this.$refs.uploadChunk.fileRemove(index)
      this.formData.isHasFile = ''
    },
    onUploadProgress(progress) {
      this.uploadLoading = true
      this.uploadProgressText = `已完成${progress}%`
    },
    onUploadSuccess(file) {
      this.uploadLoading = false
      this.fileList.push(file)
      if (!this.tableData[file.id]) {
        this.$set(this.tableData, file.id, [])
      }
      this.formData.isHasFile = this.fileList.length === 0 ? '' : true
      this.$refs.vioFormItem.$emit('el.form.change')
    },
    // 详情
    async initInfoData() {
      const [err, res] = await coursewareApi.getCourseware({ id: this.operateData.id })
      if (err) return
      Object.keys(this.formData).forEach((key) => {
        this.formData[key] = res[key]
      })
      this.formData.isHasFile = true
      res.materials.forEach((item) => {
        this.fileList.push({ id: item.fileId, fileName: item.name })
        this.$set(this.videoTimeLen, item.fileId, item.times)
        if (item.nodes.length) {
          item.nodes.forEach((tabVal) => {
            tabVal.questions.forEach((questionItem) => {
              const valItem = {
                examType: questionItem.questionType,
                topic: questionItem.topic,
                topicContent: questionItem.content,
                topicIllustrated: questionItem.picture,
                correct: questionItem.answer,
                answerAnalysis: questionItem.analysis,
                time: tabVal.nodeTime,
              }
              if (this.tableData[item.fileId]) {
                this.tableData[item.fileId].push(valItem)
              } else {
                this.$set(this.tableData, item.fileId, [valItem])
              }
            })
          })
        } else {
          this.$set(this.tableData, item.fileId, [])
        }
      })
      this.initVideoPoster(this.formData.cover)
      this.$nextTick(() => {
        // this.fileList.length && this.$refs.uploadComVio.setFile(this.fileList)
      })
    },
    async initVideoPoster(imgStr) {
      // 获取图片内容
      const [err, res] = await fileApi.getFileContent(imgStr)
      if (!err) {
        const picTrue = [{ id: imgStr, fileName: res.name }]
        this.$refs.uploadComPic.setFile(picTrue)
      }
    },
    // 关联题目
    addRiskPoint(data) {
      this.pointProps.visible = false
      this.pointDialog = false
      const val = data.map((item) => {
        const obj = { ...item, time: this.currentTime, id: this.currentId }
        return obj
      })
      const lastValIndex = this.tableData[this.currentId].findLastIndex((item) => {
        return item.time === this.currentTime
      })

      const delIndex = this.tableData[this.currentId][lastValIndex].topic ? 0 : 1
      this.tableData[this.currentId].splice(lastValIndex, delIndex, ...val)
    },
    // 解除题目
    removeTopic(index, id) {
      if (this.tableData[id].length === 1) {
        const val = this.tableData[id][0]
        this.tableData[id] = [{ time: val.time }]
      } else {
        this.tableData[id].splice(index, 1)
      }
    },
    // 设置节点
    onClick(data, id) {
      const time = data.set()
      const isOk = this.tableData[id].find((item) => {
        return item.time === time
      })
      if (isOk) {
        this.$message.warning('已存在同一时间节点')
        return
      }
      this.tableData[id].push({ time })
    },
    // 清除节点
    clearNode(time, id) {
      this.$confirm('此操作将删除此节点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: (action) => {
          if (action === 'confirm') {
            this.tableData[id] = this.tableData[id].filter((item) => {
              return item.time !== time
            })
          }
        },
      })
    },
    // 关联题目
    linkTopic(time, id) {
      this.currentId = id
      this.currentTime = time
      this.pointProps.visible = true
      this.pointDialog = true
    },
    // 接收视频长度
    sentTime(time, id) {
      this.$set(this.videoTimeLen, id, time)
    },
    // 文件显示
    updateFile(val, type, name) {
      if (type === 'picture') {
        if (val.length) {
          this.formData.cover = val[0].id
        } else {
          this.formData.cover = ''
        }
      } else {
        this.fileList = val || []
        this.fileList.forEach((item) => {
          if (!this.tableData[item.id]) {
            this.$set(this.tableData, item.id, [])
          }
        })
        this.formData.isHasFile = val.length === 0 ? '' : true
      }
      this.$refs[name].$emit('el.form.change')
    },
    // 删除文件
    deleteFile(id) {
      delete this.tableData[id]
    },
    async submitForm() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          const data = { ...this.formData, materials: [] }
          this.fileList.forEach((item, index) => {
            const val = {
              fileId: item.id,
              name: item.fileName,
              times: this.videoTimeLen[item.id],
              nodes: [],
              orderNo: index,
            }
            const timeLinkTopic = {}
            this.tableData[item.id].forEach((tabVal) => {
              const questionItem = {
                questionType: tabVal.examType,
                topic: tabVal.topic,
                content: tabVal.topicContent,
                picture: tabVal.topicIllustrated,
                answer: tabVal.correct,
                analysis: tabVal.answerAnalysis,
                orderNo: timeLinkTopic[tabVal.time]?.length || 0,
              }
              if (timeLinkTopic[tabVal.time]) {
                timeLinkTopic[tabVal.time].push(questionItem)
              } else {
                timeLinkTopic[tabVal.time] = [questionItem]
              }
            })
            Object.keys(timeLinkTopic).forEach((time) => {
              val.nodes.push({ nodeTime: time, questions: timeLinkTopic[time] })
            })
            data.materials.push(val)
          })
          if (this.operateType === 'update') {
            data.id = this.operateData.id
          }
          this.loading = true
          const [err, res] = await coursewareApi[
            this.operateType === 'update' ? 'update' : 'insert'
          ]({
            body: data,
          })
          this.loading = false
          if (err) return
          this.$message.success('提交成功')
          this.$emit('success')
          this.dialogVisible = false
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-icon-arrow-right {
  display: none;
}
</style>
